<a
  mat-stroked-button
  color="warn"
  class="make-call"
  [href]="'tel:' + phoneNumberFull"
>
  <mat-icon>phone</mat-icon>
  <span>Позвонить</span>
</a>
